import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactSection from "../components/home/ContactSection";
import { Mail, Phone, MapPin } from "lucide-react";

const ContactPage = () => {
  const contactInfo = [
    {
      icon: Mail,
      label: "Email",
      value: "info@goldencortex.net",
      href: "mailto:info@goldencortex.net"
    },
    {
      icon: Phone,
      label: "Phone",
      value: "+34 617 500 996",
      href: "tel:+34617500996"
    },
    {
      icon: MapPin,
      label: "Location",
      value: "Spain",
      href: "#"
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Get in{" "}
              <span className="text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text">
                Touch
              </span>
            </h1>
            <p className="text-gray-300 text-lg md:text-xl mb-12 max-w-3xl mx-auto">
              Ready to revolutionize your real estate business with AI? Let's discuss how we can help you close more deals.
            </p>

            {/* Contact Info Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {contactInfo.map((info, index) => {
                const IconComponent = info.icon;
                return (
                  <a
                    key={index}
                    href={info.href}
                    className="bg-gray-900/50 border border-gray-700 rounded-lg p-6 text-center hover:border-yellow-400 transition-all duration-300 transform hover:scale-105 group"
                  >
                    <div className="w-12 h-12 mx-auto mb-4 bg-yellow-400 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="w-6 h-6 text-black" />
                    </div>
                    <h3 className="text-white font-semibold mb-2">{info.label}</h3>
                    <p className="text-gray-300 group-hover:text-yellow-400 transition-colors">
                      {info.value}
                    </p>
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;